/**
 * Display helpers for raw identifiers (column / field names).
 *
 * The portal shows database column names (`company_name`, `close_date`) in
 * table headers + form labels. Humanise them for display — Asana-style
 * sentence-case — WITHOUT touching the raw name, which stays the key used for
 * sort / filters / cell lookup / payload.
 */

/** `company_name` → "Company name"; `close_date` → "Close date". */
export function humanizeColumn(c: string): string {
  const s = c.replace(/[_-]+/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
